/** 当前已接通的登录方式；新增认证提供方时先注册能力，再交给通用选择器展示。 */
export type LoginMethod = 'phone' | 'password' | 'wechat' | 'appqr';

/** 兼容尚未下发方式列表的 Platform，手机号仍是页面默认方式。 */
export const DEFAULT_LOGIN_METHODS: readonly LoginMethod[] = ['password', 'wechat', 'appqr', 'phone'];

/**
 * 解析 Platform status.login_methods 的有序 ID 数组；未下发时返回 undefined 走原顺序。
 * 去重并忽略未接通的提供方，不接受配置中的任意脚本或跳转地址。
 */
export function parseLoginMethods(value: unknown): LoginMethod[] | undefined {
  if (!Array.isArray(value)) return undefined;
  const methods = [...new Set(value.filter((id): id is LoginMethod =>
    typeof id === 'string' && DEFAULT_LOGIN_METHODS.includes(id as LoginMethod),
  ))];
  return methods.length ? methods : undefined;
}
